export default "/images/49cdb710f9710e0e63a2b9677f384d7f.jpg";